import { User } from "../../../types/session";

export const fetchUser = async (url: string): Promise<User | undefined> => {
  const response = await fetch(url, { credentials: "same-origin" });
  if (response.ok) {
    return await response.json();
  } else {
    return undefined;
  }
};
